module.exports = __webpack_public_path__ + "img/bar2.80f7f372.png";